// extracted by mini-css-extract-plugin
export default {"cls1":"PaperInteractions-cls1__e30d18fc6cbd8285c7b6","cls2":"PaperInteractions-cls2___7d349d095c348e6c943 PaperInteractions-cls1__e30d18fc6cbd8285c7b6"};